import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Avatar, Flex, Typography, theme, Grid } from "antd";
import FavoritesComponent from "./../../../components/favoritesComponent/FavoritesComponent.js";
import { FAVORITE_CATEGORIES } from "./../../../components/favoritesComponent/favoritesService.js";
import { Link } from "react-router-dom";
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;
const PlayerHeader = ({
  photoUrl,
  name,
  currentTeam,
  isFavorite,
  itemId,
  children
}) => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "content-gray-box teams-header",
      style: { paddingBottom: 0 },
      children: [
        /* @__PURE__ */ jsxs(
          Flex,
          {
            style: { marginBottom: screens.md ? 16 : 12 },
            justify: "space-between",
            children: [
              /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    src: photoUrl,
                    shape: "square",
                    size: 48,
                    style: {
                      borderRadius: 0,
                      flexShrink: 0
                    }
                  }
                ),
                /* @__PURE__ */ jsxs(Flex, { vertical: true, children: [
                  /* @__PURE__ */ jsx(
                    Title,
                    {
                      level: 3,
                      style: { marginTop: 0, marginBottom: 4 },
                      children: name
                    }
                  ),
                  /* @__PURE__ */ jsx(Link, { to: `/team/${currentTeam == null ? void 0 : currentTeam.id}`, children: /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                    /* @__PURE__ */ jsx(
                      Avatar,
                      {
                        src: currentTeam == null ? void 0 : currentTeam.iconUrl,
                        shape: "square",
                        size: 26,
                        style: {
                          borderRadius: 0,
                          flexShrink: 0
                        }
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Text,
                      {
                        style: {
                          color: token.colorTextBase
                        },
                        children: currentTeam == null ? void 0 : currentTeam.displayName
                      }
                    )
                  ] }) })
                ] })
              ] }),
              /* @__PURE__ */ jsx(
                FavoritesComponent,
                {
                  category: FAVORITE_CATEGORIES.PLAYER,
                  itemId,
                  isFavorite
                }
              )
            ]
          }
        ),
        children
      ]
    }
  );
};
var stdin_default = memo(PlayerHeader);
export {
  stdin_default as default
};
